<template>
<div>
	<ppe-form 
		entityName="D3"
		title="D3. Livret d'Accueil Prévention EE"
		title-field="{company.name}, {operation.code}, {operation.operationname}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_ee/operation_home/:operationid'" 
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
</div>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		var self = this;
		console.log("this.$route.query.operationid", this.$route.query.operationid)
		return {
			endpoint : "/ee/d3?id=" + this.$route.params.id+'&operationid='+this.$route.query.operationid+"&companyid="+this.$route.query.companyid,
			dangers: {},
			schema : [

				{ card:"Analyse des dangers et des risques récurrents (à comparer aux risques du site d'accueil)", 
				  id:'risks',
					body:[
						{name:"reccurrentDangers",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','E.E.\n(Votre Entreprise)', 'RISQUES RECURRENTS','CAUSES / CONSEQUENCES POTENTIELLES','MESURES DE PRÉVENTION'],
								options:Business.reccurrentDangers,
						},
						{
							type:"checkbox",
							name:"all_done",
							label:"Tous les risques sont complétés",
						},
						{component:'h5', children:"Nouveaux risques générés ponctuellement liés à la spécificité de l'opération de l'EE", size:"large"},
						{
							type:'group', repeatable: true,
							name: 'ponctualRisks', label : 'Identification des risques',
							addLabel: 'Ajouter un risque', validation : "min:0,length", size: 'large',
							children:[
									{ component: 'div', class:'display-inline', children:[
										{name:"description",   			label:"Identification des risques",     type: "textarea",  validation: '', class:'col-md-4'},
										{name:"consequences",  			label:"Causes / conséquences",          type: "textarea",  validation: '', class:'col-md-4'},
										{name:"prevention",   			label:"Mesures de prévention",          type: "textarea",  validation: '', class:'col-md-4'},
									]},
							]
						},
					], 
				},

				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				
				],
		}
	},
	methods : {
		ParentHasDanger(danger) {
			console.log("ParentHasDanger", danger, this.dangers)
			//return this.reccurrentDangersParent && this.reccurrentDangersParent.includes(danger) ? ["☑"]:["☐"]

			return this.dangers ? this.dangers[danger] : ''
		},
		onDataLoaded(data) {
			console.log("D3.onDataLoaded(data)", data)
			// Do not add columns and checboxes because the entities are same
			if(!data.parentB3 || data.parentB3.id === data.entity.id) return

			// Clone the schema to avoid alter the in memory risks
			let clonedSchema = JSON.parse(JSON.stringify(this.schema))
			//Add the E.U. column to compare with the EU checkboxes
			let risks = clonedSchema.find( e => e.id==='risks')

			// Unselect all
			for(var opt of risks.body[0].options) {
				opt.prefixValues = ['.']
			}
			// Select those that matches
			for(var d of data.parentB3.reccurrentDangers) {
				let opt = risks.body[0].options.find( o => o.value===d)
				if(opt)
					opt.prefixValues = ['☑'] // 
			}

			risks.body[0].columns.splice(1, 0, 'E.U. (Site d\'accueil)')

			console.log("this.dangers", this.dangers)
			this.schema = [...clonedSchema, undefined] // force a refresh
		}
	}
};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
